/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Mobile_Character_CountInputs */

const en_mobile_character_count = /** @type {(inputs: Mobile_Character_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} character`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} characters`);
	return /** @type {LocalizedString} */ ("mobile_character_count");
};

const es_mobile_character_count = /** @type {(inputs: Mobile_Character_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} carácter`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} caracteres`);
	return /** @type {LocalizedString} */ ("mobile_character_count");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} character" |
* | "other" | "{count} characters" |
*
* @param {Mobile_Character_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_character_count = /** @type {((inputs: Mobile_Character_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Character_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_character_count(inputs)
	return en_mobile_character_count(inputs)
});